import { render, staticRenderFns } from "./HeadListEmployee.vue?vue&type=template&id=52f645f1&"
import script from "./HeadListEmployee.vue?vue&type=script&lang=js&"
export * from "./HeadListEmployee.vue?vue&type=script&lang=js&"
import style0 from "./HeadListEmployee.vue?vue&type=style&index=0&id=52f645f1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports